import { RulebookPage } from "@/components/RulebookPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { currentRules } from "@/data/rules";
import { DescriptionBlocks } from "./DescriptionBlocks";

export function Cabals() {
  const patronMap = Object.fromEntries(
    currentRules.patrons.map((p) => [p.id, p.name])
  );

  return (
    <RulebookPage title="Cabals">
      <p className="text-sm text-muted-foreground mb-3">
        A Cabal is a (very) loosely organised group of Warlocks with common
        interests. Members of a Cabal often work together to meet their shared
        goals, and find instant companionship when meeting members of the same
        Cabal.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        You may begin the game as a member of one Cabal you meet the
        requirements to join.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        Each of the Cabals listed below are the most prolific groups you might
        encounter, but in an infinite multiverse, there are endless
        possibilities for potentially creating your own Cabal... If you wish to
        create your own custom Cabal, you will need to convince at least one
        Patron to endorse you first!
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Favoured Patrons</h2>
      <p className="text-sm text-muted-foreground mb-3">
        Members of each Cabal live their lives in a way that give them an edge
        when entering the Challenge of 13.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        Cabal members count as having already completed the Patron Challenges of
        one Favoured Patron of their choice when entering the festival grounds,
        allowing them to quickly and easily summon certain Patrons on the first
        day.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        If a Warlock chooses to use this ability when performing a summoning,
        feel free to invent the ways in which you completed these Challenges
        &quot;off-screen&quot; before the game even began when you announce your
        accomplishments during the ritual!
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        You may only belong to one Cabal at a time. However, you may switch your
        allegiance as you see fit, though you do not gain the bonuses of your
        new Cabal until the next Challenge of 13.
      </p>

      {currentRules.cabals.map((cabal) => (
        <Card key={cabal.id} className="mb-3">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">{cabal.name}</CardTitle>
            <div className="flex flex-wrap gap-1 pt-1">
              {cabal.favouredPatronIds.map((pid) => (
                <Badge key={pid} variant="outline" className="text-xs">
                  {patronMap[pid] ?? pid}
                </Badge>
              ))}
            </div>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground space-y-3">
            <DescriptionBlocks blocks={cabal.description} />

            <div>
              <p className="font-semibold text-foreground">
                Membership Requirements
              </p>
              <p>{cabal.requirements}</p>
            </div>

            <div>
              <p className="font-semibold text-foreground">Costuming</p>
              <p>{cabal.costuming}</p>
            </div>
          </CardContent>
        </Card>
      ))}

      <h2 className="text-xl font-semibold mt-6 mb-2">Custom Cabals</h2>
      <p className="text-sm text-muted-foreground mb-3">
        Rumour has it that smaller, independent Cabals with unusual combinations
        of Favoured Patrons are proliferating in the edges of Warlock society,
        and gaining followers. The Bureau of Eldritch Administration encourages
        any curious Warlocks to disregard these rumours, and stick to the
        existing seven Cabals in the interest of neatness and efficiency.
      </p>
      <p className="text-sm text-muted-foreground mb-3">
        They most certainly do NOT recommend approaching Patrons and asking them
        to favour your new, unique grassroots Cabal, and most certainly would
        like to disincentivise you from recruiting your friends and allies to
        join your new so-called Cabal. Any independent Cabal activity should be
        reported to your nearest Bureau authority.
      </p>
    </RulebookPage>
  );
}
